import { Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { EntityEnum } from "../../EntityEnum";
import { MeddraQueryNode } from "../MeddraQueryNode";
import { MeddraLevel } from "../MeddraNode";
import { BaseNode } from "../../BaseNode";

export class LLTQueryNode extends MeddraQueryNode {
    constructor(injector: Injector, entityNode: BaseNode|null) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinition(injector).lltQueryFields;

    const queryConditions: FormlyFieldConfig[] = new FieldDefinition(injector).queryConditions;
       super(injector, [], MeddraLevel.LLT, EntityEnum.llt, queryFields, queryConditions, entityNode);
    }    
}